import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../services"
import { REQUESTS_SLICE_NAME } from "./requests.constants"

export const saveScreenshotsRequest = createAsyncThunk(
  `${REQUESTS_SLICE_NAME}/save_screenshots_request`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.saveScreenshotsRequest(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const updateCommentRequest = createAsyncThunk(
  `${REQUESTS_SLICE_NAME}/update_comment_request`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.updateCommentRequest(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    // A 204 carries no body; the saga fell back to the request params there, and the
    // reducer merges whatever comes back into `selectedRequest`.
    return response.data || params
  }
)

export const deleteScreenshotsRequest = createAsyncThunk(
  `${REQUESTS_SLICE_NAME}/delete_screenshots_request`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.deleteScreenshotsRequest(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return { id: params.id, message: response.data?.message?.detail || response.data?.message }
  }
)
